import {Routes} from '@angular/router';
import {CreateQuoteComponent} from './create-quote/create-quote.component';
import {SelectTemplateComponent} from "./select-template/select-template.component";
import {SelectBespokeTemplateComponent} from "./bespoke-template/select-bespoke-template";
import {QuoteDetailsComponent} from "./quote-details/quote-details.component";
import {CreateBespokeQuoteComponent} from "./create-bespoke-quote/create-bespoke-quote.component";
import {ViewPlanImageComponent} from "./view-plan-image/view-plan-image.component";
import {RemoveAndRefitComponent} from "./create-remove-and-refit/create-remove-and-refit.component";

export const quoteRoutes: Routes = [
  {path: '', redirectTo: 'create', pathMatch: 'full'},
  {path: 'selecttemplate', component: SelectTemplateComponent},
  {path: 'selectbespoketemplate', component: SelectBespokeTemplateComponent},
  {path: 'create/:templateId', component: CreateQuoteComponent},
  {path: 'createbespoke/:templateId', component: CreateBespokeQuoteComponent},
  {path: 'viewplanimage/:planId', component: ViewPlanImageComponent},
  {path: 'createremoveandrefit/:id', component: RemoveAndRefitComponent},
  {path: ':id', component: QuoteDetailsComponent}
];
